import { render } from "./Payments.vue?vue&type=template&id=021b89fa&scoped=true&ts=true"
import script from "./Payments.vue?vue&type=script&lang=ts"
export * from "./Payments.vue?vue&type=script&lang=ts"

import "./Payments.vue?vue&type=style&index=0&id=021b89fa&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021b89fa"]])

export default __exports__